import React, {
  useState,
  useRef,
  useContext,
  useCallback,
  useEffect,
  Fragment,
} from "react";
import {
  IconButton,
  Paper,
  MenuList,
  MenuItem,
  Divider,
  Popper,
  Grow,
  ClickAwayListener,
  Badge,
  Fade,
  Typography,
  List,
  ListItem,
  // Button,
} from "@material-ui/core";
import useReactRouter from "use-react-router";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { FaExclamationCircle, FaBell } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import { LangContext } from "../../Context/Langcontext";
import { useSnackbar } from "notistack";
import { UserContext } from "../../Context/UserContext";
import { editNotification, addNotification } from "../../API/Notification";
const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 0,
    top: 5,
    padding: "0 4px",
    backgroundColor: "#ed2840",
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    width: "100%",
  },
  paper: {
    boxShadow: "unset",
    border: "1px solid #BFC0BF",
    minWidth: 360,
    maxWidth: 360,
    maxHeight: 600,
    overflowY: "auto",
  },
  paperall: {
    boxShadow: "unset",
    border: "1px solid #BFC0BF",
    minWidth: 360,
    maxWidth: 360,
    minHeight: 600,
    maxHeight: 600,
    overflowY: "auto",
  },
  titletext: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "#595A5A",
  },
  detailtext: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  timetext: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#E16733",
  },
  notiheadtext: {
    textAlign: "center",
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 700,
    margin: "1rem",
  },
  datefont: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 400,
  },
  btnview: {
    textTransform: "unset",
    fontSize: "1rem",
    color: "#595A5A",
    borderRadius: 25,
    fontWeight: 700,
  },
  unreadIcon: {
    fontSize: "2rem",
    color: "#E16733",
    marginRight: "1rem",
  },
  icon: {
    fontSize: "2rem",
    color: "#595A5A",
    marginRight: "1rem",
  },
  root: {
    display: "flex",
    alignItems: "center",
  },
  massagebox: { padding: "1rem" },
}));

const Useractive = () => {
  const classse = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const { history } = useReactRouter();
  const [onPath, setOnPath] = useState("/app/api");
  const [noti, setNoti] = useState(0);
  const [opennoti, setOpennoti] = useState(false);
  const [notiref, setNotiref] = useState(null);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { enqueueSnackbar } = useSnackbar();
  const user = useContext(UserContext);
  const [view, setView] = useState(false);
  const [rundata, setRundata] = useState(false);
  const [list, setList] = useState([
    // {
    //   title: "API Limit",
    //   time: "11.15 am.",
    //   detail: "Your usage has reached the limit",
    // },
  ]);

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const SignOut = (event) => {
    localStorage.clear();
    user.setSum({
      _id: {},
      sum_cost: 0,
      sum_net: 0,
      sum_request: 0,
      sum_size: 0,
      sum_vat: 0,
      balance: 0,
    });
    user.setPayment([]);
    user.setNotification([]);
    setOpen(false);
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.replace("/home/main");
    enqueueSnackbar(lang.LogoutSuccessfully, {
      variant: "success",
    });
  };

  const goApiconsole = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
    if (localStorage.getItem("role") === "admin") {
      history.push("/app/dashboard");
    } else if (localStorage.getItem("role") === "root") {
      history.push("/app/dashboard");
    } else {
      history.push("/app/api");
    }
  };

  const goUserconfig = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    history.push("/app/user");
  };
  const UserListItem = () => {
    return (
      <Paper className={classse.cardStyle}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList
            autoFocusItem={open}
            id="menu-list-grow"
            onKeyDown={handleListKeyDown}
          >
            <MenuItem
              onClick={goApiconsole}
              style={{
                margin: "0.5rem",
                color:
                  onPath.startsWith("/app") && !onPath.startsWith("/app/user")
                    ? "#E16733"
                    : "#595A5A",
                fontWeight: 200,
                borderRadius: 25,
              }}
            >
              {lang.APIConsole}
            </MenuItem>
            <MenuItem
              onClick={goUserconfig}
              style={{
                margin: "0.5rem",
                color:
                  !onPath.startsWith("/app/useradmin") &&
                  onPath.startsWith("/app/user")
                    ? "#E16733"
                    : "#595A5A",
                fontWeight: 200,
                borderRadius: 25,
              }}
            >
              {lang.UserProfile}
            </MenuItem>
            <Divider variant="middle" />
            <MenuItem
              onClick={SignOut}
              style={{
                margin: "0.5rem",
                color: "#E16733",
                fontWeight: 400,
                borderRadius: 25,
              }}
            >
              {lang.Signout}
            </MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Paper>
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = React.useRef(open);

  const convertTime = (date) => {
    let time = date.toLocaleTimeString();

    let output = `${time}`;
    return output;
  };

  const convertDate = useCallback(
    (date) => {
      const monthNames = [
        lang.January,
        lang.February,
        lang.March,
        lang.April,
        lang.May,
        lang.June,
        lang.July,
        lang.August,
        lang.September,
        lang.October,
        lang.November,
        lang.December,
      ];

      let dateObj = new Date(date);
      let month = monthNames[dateObj.getMonth()];
      let day = String(dateObj.getDate()).padStart(2, "0");
      let year = dateObj.getFullYear();

      let output = `${day} ${month} ${
        langContext.lang.locale === "th" ? Number(year + 543) : year
      }`;
      return output;
    },
    [langContext, lang]
  );

  const onsetInfo = useCallback(async () => {
    let dataShow = [];

    if (
      localStorage.getItem("role") === "admin" ||
      localStorage.getItem("role") === "root"
    ) {
    } else {
      if (user.sum.fetch) {
        dataShow.push(...user.notification);
        // last3days.setDate(new Date().getDate() - 7);
        if (user.payment.length !== 0) {
          if (user.sum.balance === 0) {
            const check0 = user.notification.filter((rs) => {
              return rs.topic === "วงเงินของคุณหมดแล้ว";
            });

            if (check0.length) {
              let last3days = new Date();
              last3days.setDate(new Date().getDate() - 3);
              if (last3days > new Date(check0[0].created_at)) {
                let input0 = {
                  topic: "วงเงินของคุณหมดแล้ว",
                  message: "หากต้องการใช้งาน API กรุณาเติมเครดิต",
                  user_id: localStorage.getItem("uid"),
                };
                const add = await addNotification(input0);
                if (add.status.code === 201) {
                  user.setNotification([...user.notification, add.data[0]]);
                  dataShow.push(add.data[0]);
                }
              }
            } else {
              let input0 = {
                topic: "วงเงินของคุณหมดแล้ว",
                message: "หากต้องการใช้งาน API กรุณาเติมเครดิต",
                user_id: localStorage.getItem("uid"),
              };
              const add = await addNotification(input0);
              if (add.status.code === 201) {
                user.setNotification([...user.notification, add.data[0]]);
                dataShow.push(add.data[0]);
              }
            }
          } else {
            if (user.sum.balance < 50) {
              const check50 = user.notification.filter((rs) => {
                return rs.topic === "วงเงินของคุณ";
              });
              if (check50.length) {
                let last3days = new Date();
                last3days.setDate(new Date().getDate() - 3);
                if (last3days > new Date(check50[0].created_at)) {
                  let input50 = {
                    topic: "วงเงินของคุณ",
                    message: "เหลือน้อยกว่า 50 บาท",
                    user_id: localStorage.getItem("uid"),
                  };
                  const add = await addNotification(input50);
                  if (add.status.code === 201) {
                    user.setNotification([...user.notification, add.data[0]]);
                    dataShow.push(add.data[0]);
                  }
                } else {
                }
              } else {
                let input50 = {
                  topic: "วงเงินของคุณ",
                  message: "เหลือน้อยกว่า 50 บาท",
                  user_id: localStorage.getItem("uid"),
                };
                const add = await addNotification(input50);
                if (add.status.code === 201) {
                  user.setNotification([...user.notification, add.data[0]]);
                  dataShow.push(add.data[0]);
                }
              }
            }
          }

          if (
            localStorage.getItem("role") === "public" ||
            localStorage.getItem("role") === "contract"
          ) {
            let fortnightAway = new Date(Date.now() + 12096e5);

            if (
              convertDate(new Date()) ===
              convertDate(new Date(user.state.contract.end_date))
            ) {
              const checkemp = user.notification.filter((rs) => {
                return rs.message === "บัญชีของคุณได้หมดอายุการใช้งานแล้ว";
              });
              if (checkemp.length !== 0) {
                let last7days = new Date();
                last7days.setDate(new Date().getDate() - 7);
                if (last7days > new Date(checkemp[0].created_at)) {
                  let input = {
                    topic: "อายุการใช้งาน",
                    message: "บัญชีของคุณได้หมดอายุการใช้งานแล้ว",
                    user_id: localStorage.getItem("uid"),
                  };
                  const add = await addNotification(input);
                  if (add.status.code === 201) {
                    user.setNotification([...user.notification, add.data[0]]);
                    dataShow.push(add.data[0]);
                  }
                }
              } else {
                let input = {
                  topic: "อายุการใช้งาน",
                  message: "บัญชีของคุณได้หมดอายุการใช้งานแล้ว",
                  user_id: localStorage.getItem("uid"),
                };
                const add = await addNotification(input);
                if (add.status.code === 201) {
                  user.setNotification([...user.notification, add.data[0]]);
                  dataShow.push(add.data[0]);
                }
              }
            } else {
              if (fortnightAway > new Date(user.state.contract.end_date)) {
                const check14 = user.notification.filter((rs) => {
                  return (
                    rs.message ===
                    `บัญชีของคุณจะหมดอายุการใช้งานในวันที่ ${convertDate(
                      new Date(user.state.contract.end_date)
                    )}`
                  );
                });
                if (check14.length !== 0) {
                  let last7days = new Date();
                  last7days.setDate(new Date().getDate() - 7);
                  if (last7days > new Date(check14[0].created_at)) {
                    let input = {
                      topic: "อายุการใช้งาน",
                      message: `บัญชีของคุณจะหมดอายุการใช้งานในวันที่ ${convertDate(
                        new Date(user.state.contract.end_date)
                      )}`,
                      user_id: localStorage.getItem("uid"),
                    };
                    const add = await addNotification(input);
                    if (add.status.code === 201) {
                      user.setNotification([...user.notification, add.data[0]]);
                      dataShow.push(add.data[0]);
                    }
                  }
                } else {
                  let input = {
                    topic: "อายุการใช้งาน",
                    message: `บัญชีของคุณจะหมดอายุการใช้งานในวันที่ ${convertDate(
                      new Date(user.state.contract.end_date)
                    )}`,
                    user_id: localStorage.getItem("uid"),
                  };
                  const add = await addNotification(input);
                  if (add.status.code === 201) {
                    user.setNotification([...user.notification, add.data[0]]);
                    dataShow.push(add.data[0]);
                  }
                }
              }
            }
          }

          const num = dataShow.filter((rs) => {
            return rs.readed === 0;
          });

          setList(dataShow);
          setNoti(num.length);
          setRundata(true);
        } else {
          const num = dataShow.filter((rs) => {
            return rs.readed === 0;
          });
          setList(dataShow);
          setNoti(num.length);
          setRundata(true);
        }
      } else {
        setRundata(false);
      }
      // if (user.payment.length !== 0) {
      //   if (user.sum.balance === 0) {
      //     datalist.push({
      //       title: "วงเงินของคุณหมดแล้ว",
      //       detail: "หากต้องการใช้งาน API กรุณาเติมเครดิต",
      //       time: convertTime(new Date()),
      //     });
      //   } else {
      //     if (user.sum.balance < 50) {
      //       datalist.push({
      //         title: "วงเงินของคุณ",
      //         detail: "เหลือน้อยกว่า 50 บาท",
      //         time: convertTime(new Date()),
      //       });
      //     }
      //   }
      //   if (
      //     localStorage.getItem("role") === "public" ||
      //     localStorage.getItem("role") === "contract"
      //   ) {
      //     let fortnightAway = new Date(Date.now() + 12096e5);
      //     console.log(fortnightAway);
      //     if (
      //       convertDate(new Date()) ===
      //       convertDate(new Date(user.state.contract.end_date))
      //     ) {
      //       datalist.push({
      //         title: "อายุการใช้งาน",
      //         detail: "บัญชีของคุณได้หมดอายุการใช้งานแล้ว",
      //         time: convertTime(new Date()),
      //       });
      //     } else {
      //       if (fortnightAway > new Date(user.state.contract.end_date)) {
      //         datalist.push({
      //           title: "อายุการใช้งาน",
      //           detail: `บัญชีของคุณจะหมดอายุการใช้งานในวันที่ ${convertDate(
      //             new Date(user.state.contract.end_date)
      //           )}`,
      //           time: convertTime(new Date()),
      //         });
      //       }
      //     }
      //   }
      // } else {
      //   setRundata(true);
      // }
    }
  }, [user, convertDate]);

  useEffect(() => {
    if (!rundata) {
      onsetInfo();
    } else {
    }
  }, [rundata, onsetInfo]);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
    setOnPath(history.location.pathname);
  }, [open, history]);

  const onReaded = (e) => {
    setOpennoti(!opennoti);
    setNoti(0);
    setNotiref(e.currentTarget);

    const notreaded = list.filter((rs) => {
      return rs.readed !== 1;
    });

    if (notreaded.length !== 0) {
      notreaded.map(async (rs) => {
        let input = {
          readed: 1,
        };
        let read = await editNotification(rs._id, input);
        return read;
      });
    }
  };

  return (
    <div className={classse.root}>
      <IconButton
        onClick={(e) => {
          if (list.length) {
            onReaded(e);
          }
        }}
      >
        <StyledBadge badgeContent={noti} color="primary">
          <FaBell color="#929393" size={28} />
        </StyledBadge>
      </IconButton>

      <Popper
        open={opennoti}
        anchorEl={notiref}
        placement={"bottom-end"}
        transition
        style={{ zIndex: 25 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className={view ? classse.paperall : classse.paper}>
              <ClickAwayListener
                onClickAway={() => {
                  setOpennoti(false);
                  setView(false);
                }}
              >
                <div style={{ margin: "0.5rem" }}>
                  {list.filter((rs) => {
                    return rs.readed === 0;
                  }).length ? (
                    <Fragment>
                      <Typography className={classse.notiheadtext}>
                        {lang.YouHave}{" "}
                        {
                          list.filter((rs) => {
                            return rs.readed === 0;
                          }).length
                        }{" "}
                        {lang.Pendingtask} !
                      </Typography>
                      <Divider />
                    </Fragment>
                  ) : null}

                  {/* {list.length ? (
                    <Typography className={classse.datefont}>
                      {convertDate(new Date())}
                    </Typography>
                  ) : null} */}

                  <List>
                    {list
                      .sort((a, b) => {
                        return a.created_at < b.created_at ? 1 : -1;
                      })
                      .map((res, index) => {
                        return (
                          <Fragment key={`${res.title}_${index}`}>
                            {list[index - 1] &&
                            convertDate(
                              new Date(list[index - 1].created_at)
                            ) ===
                              convertDate(new Date(res.created_at)) ? null : (
                              <Typography className={classse.datefont}>
                                {convertDate(new Date(res.created_at))}
                              </Typography>
                            )}
                            <ListItem
                              // button
                              className={classse.massagebox}
                              style={{
                                backgroundColor: "#f6f6f6",
                                marginBottom: "0.5rem",
                                marginTop: index > 0 ? "0.5rem" : 0,
                              }}
                            >
                              <div style={{ display: "flex", width: "100%" }}>
                                <FaExclamationCircle
                                  className={
                                    res.readed === 0
                                      ? classse.unreadIcon
                                      : classse.icon
                                  }
                                />
                                <div style={{ width: "100%" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography className={classse.titletext}>
                                      {res.topic !== "" ? res.topic : "-"}
                                    </Typography>
                                    <Typography className={classse.timetext}>
                                      {convertTime(new Date(res.created_at))}
                                    </Typography>
                                  </div>

                                  <Typography className={classse.detailtext}>
                                    {res.message}
                                  </Typography>
                                </div>
                              </div>
                            </ListItem>
                            <Divider />
                          </Fragment>
                        );
                      })}
                  </List>
                  {/* {view ? null : (
                    <Button
                      fullWidth
                      className={classse.btnview}
                      onClick={() => {
                        setView(true);
                      }}
                    >
                      {lang.ViewAll}
                    </Button>
                  )} */}
                </div>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>

      <IconButton
        onClick={handleToggle}
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
      >
        {user.state.profile_picture !== "" ? (
          <img
            alt="profile_img"
            src={user.state.profile_picture}
            width={32}
            height={32}
            style={{ borderRadius: 32 / 2 }}
          />
        ) : (
          <MdAccountCircle color="#E16733" size={32} />
        )}
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-end"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <UserListItem />
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default Useractive;
